import { render, staticRenderFns } from "./testOrderList.vue?vue&type=template&id=4ab9a066&scoped=true&"
import script from "./testOrderList.vue?vue&type=script&lang=js&"
export * from "./testOrderList.vue?vue&type=script&lang=js&"
import style0 from "./testOrderList.vue?vue&type=style&index=0&id=4ab9a066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab9a066",
  null
  
)

export default component.exports